import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=0c6cc3e3&scoped=true&"
import script from "./CategoryAdd.vue?vue&type=script&lang=js&"
export * from "./CategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdd.vue?vue&type=style&index=0&id=0c6cc3e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cc3e3",
  null
  
)

export default component.exports